import type React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ClientAboutEditPage } from '@pages/clients/client-about-page/edit-page/index.tsx';
import { ClientAboutPage } from '@pages/clients/client-about-page/index.tsx';
import { InviteModal } from '@pages/clients/invite-modal/index.ts';
import { ClientContactModal } from '@widgets/clients/client_contact_modal/ui.tsx';
import { ClientForm } from '@features/clients/client-form/';
import { GroupsPage } from '@features/clients/client-form/ui/new-groups/groups-page';
import { ClientActiveTabMobile } from '@features/clients/client-tabs';
import { useLoadColorTags } from '@features/common/load-color-tags';
import { ClientsActionsModal } from './actions-modal/ui';
import { AddClients } from './add-clients/ui';
import { AssignedConsultationModal } from './assigned-consultation-modal';
import { ClientPage } from './client-page/ui';
import { ClientsPage } from './clients-page';
import { CoachModal } from './coach-modal';
import { ConsultationModal } from './consultation-modal';
import { EditGroup } from './edit-group';
import { GroupPage } from './group-page';
import { ClientsGroupsPage } from './groups-page';
import { ModalAssign } from './modal-assign';
import { ModalSchedules } from './modal-schedules';
import { NoteEdit, ViewNotePage } from './note';
import { ProgramModal } from './program-modal';
import { ModalRecommend } from './recommend-program-modal';

type ObjStringNotation = Record<string, string>;
const getRoutes = (mainRoute: string, entityName: string): ObjStringNotation => {
  const index = `${mainRoute}${entityName}`;
  const page = `${index}/:id`;
  const edit = `${page}/edit`;
  const add = `${index}/add`;

  return {
    index,
    page,
    edit,
    add,
  } as const;
};
export const GroupsRoutesPaths = getRoutes('/clients/', 'groups');
export const Clients: React.FC = () => {
  useLoadColorTags();
  return (
    <>
      <Routes>
        {/* <Route path=":code=clients"> */}
        {/* Клиенты */}
        <Route path="clients">
          <Route index element={<ClientsPage />} />

          <Route path=":clientId">
            <Route index element={<ClientPage />} />
            <Route path="about">
              <Route index element={<ClientAboutPage />} />
              <Route path="edit" element={<ClientAboutEditPage />} />
            </Route>
          </Route>

          {/* Заметки */}
          <Route path="note">
            <Route path="view/:noteId" element={<ViewNotePage />} />
            <Route path="edit/:noteId" element={<NoteEdit />} />
          </Route>

          <Route path=":clientId/profile" element={<ClientPage />} />
          <Route path="actions" element={<ClientsActionsModal />} />

          <Route path="edit">
            <Route path=":clientId" element={<ClientForm />} />
            <Route path=":clientId/select-group" element={<GroupsPage />} />
          </Route>

          {/* Дочерние маршруты вкладок */}
          <Route path=":clientId/:tabCode">
            <Route index element={<ClientActiveTabMobile />} />
            {/* <Route element={<ClientActiveTabMobile />} /> */}
            {/* Заметки */}
            <Route path="note">
              <Route path="view/:noteId" element={<ViewNotePage />} />
              <Route path="edit/:noteId" element={<NoteEdit />} />
              <Route path="edit/new" element={<NoteEdit />} />
            </Route>
            {/* Видео */}
            <Route path="recommend">
              <Route index element={<ModalRecommend />} />
              <Route path="program/:id/specialist/:coachId" element={<CoachModal />} />
              <Route path="program/:id" element={<ProgramModal />} />
            </Route>
            {/* Консультации */}
            <Route path="assign">
              <Route index element={<ModalSchedules />} />
              <Route path="consultation/:consultationId" element={<AssignedConsultationModal />} />
              <Route path=":availableId" element={<ModalAssign />} />
            </Route>
            <Route path="consultation/:consultationId" element={<ConsultationModal />} />
          </Route>
        </Route>

        {/* Группы */}
        <Route path="groups">
          <Route index element={<ClientsGroupsPage />} />
          <Route path=":groupId">
            <Route index element={<GroupPage />} />

            {/* Заметки */}
            <Route path="note">
              <Route path="view/:noteId" element={<ViewNotePage />} />
              <Route path="edit/:noteId" element={<NoteEdit />} />
              <Route path="edit/new" element={<NoteEdit />} />
            </Route>

            <Route path=":clientId" element={<ClientPage />} />
            <Route path=":clientId/:tabCode">
              <Route index element={<ClientActiveTabMobile />} />

              {/* Заметки */}

              <Route path="note">
                <Route path="view/:noteId" element={<ViewNotePage />} />
                <Route path="edit/:noteId" element={<NoteEdit />} />
                <Route path="edit/new" element={<NoteEdit />} />
              </Route>
              {/* <Route element={<ClientActiveTabMobile />} /> */}
              {/* <Route path=":noteId" element={<NotePage />} /> */}

              {/* Видео */}
              <Route path="recommend">
                <Route index element={<ModalRecommend />} />
                <Route path="program/:id/specialist/:coachId" element={<CoachModal />} />
                <Route path="program/:id" element={<ProgramModal />} />
              </Route>

              {/* Консультации */}
              <Route path="assign">
                <Route index element={<ModalSchedules />} />
                <Route
                  path="consultation/:consultationId"
                  element={<AssignedConsultationModal />}
                />
                <Route path=":availableId" element={<ModalAssign />} />
              </Route>
              <Route path="consultation/:consultationId" element={<ConsultationModal />} />
            </Route>
          </Route>
          {/* <Route path=":groupId" element={<GroupPage />} /> */}
          <Route path="addClients">
            <Route path=":idGroup" element={<AddClients />} />
          </Route>
          <Route path="edit">
            <Route path=":idGroup" element={<EditGroup />} />
          </Route>
          {/* </Route> */}
        </Route>
      </Routes>
      <ClientContactModal />
      <InviteModal />
    </>
  );
};
